import React, { useState, useRef } from 'react';

const Chronometer = () => {
  const [time, setTime] = useState(0);
  const [running, setRunning] = useState(false);
  const intervalRef = useRef(null);

  const start = () => {
    if (!running) {
      setRunning(true);
      intervalRef.current = setInterval(() => {
        setTime(t => t + 1);
      }, 1000);
    }
  };

  const stop = () => {
    setRunning(false);
    clearInterval(intervalRef.current);
  };

  const reset = () => {
    setTime(0);
    setRunning(false);
    clearInterval(intervalRef.current);
  };

  React.useEffect(() => {
    return () => clearInterval(intervalRef.current);
  }, []);

  const pad = n => n.toString().padStart(2, '0');
  const h = Math.floor(time / 3600);
  const m = Math.floor((time % 3600) / 60);
  const s = time % 60;

  return (
    <div className="bg-white rounded-lg shadow-lg p-6 max-w-xs mx-auto flex flex-col items-center">
      <h2 className="text-2xl font-bold mb-4 text-gray-900">Cronômetro</h2>
      <div className="text-4xl font-mono mb-6 text-blue-700">{pad(h)}:{pad(m)}:{pad(s)}</div>
      <div className="flex gap-2">
        <button
          onClick={start}
          disabled={running}
          className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition disabled:opacity-50"
        >Iniciar</button>
        <button
          onClick={stop}
          disabled={!running}
          className="bg-yellow-500 text-white px-4 py-2 rounded-lg hover:bg-yellow-600 transition disabled:opacity-50"
        >Parar</button>
        <button
          onClick={reset}
          className="bg-gray-300 text-gray-800 px-4 py-2 rounded-lg hover:bg-gray-400 transition"
        >Zerar</button>
      </div>
    </div>
  );
};

export default Chronometer; 